const DEFAULT_PAGE_SIZE = 20;

const rawPageSize = Number(process.env.VUE_APP_PAGE_SIZE);

const PAGE_SIZE =
    Number.isInteger(rawPageSize) && rawPageSize > 0
        ? rawPageSize
        : DEFAULT_PAGE_SIZE;

export default PAGE_SIZE;
